module.exports = ".highlightWord {\n  color: #fe7fab; }\n"